import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setBookingField, showTeamMenu, showTimeMenu, setTeamAndBook, createBooking } from '../../store/ResourceStore';
import Unit from './Unit';
import BookingPerson from "./BookingPerson";

const TeamChooser = () => {
    const dispatch = useDispatch();
    
    const resState = useSelector((state) => state.resourceState);
    const teamState = useSelector((state) => state.teamState);
    const personState = useSelector((state) => state.personState);

    const showMenu = resState.showTeamMenu;
    if (!showMenu) return null;

    const units = resState.units;
    const teams = teamState.teams;
    const personsMap = personState.persons;
    const model = resState.createBooking;
    const bookingPerson = personsMap[model.personId];


/*
    const administration = teams.find(x => x.id === 53);
    const pladsen = teams.find(x => x.id === 53);
    const vejomraadet = teams.find(x => x.id === 22);
    const gronvej = teams.find(x => x.id === 26);

    const komunaleEjendome = teams.find(x => x.id === 23);
    const team2 = teams.find(x => x.id === 28);
    const team3 = teams.find(x => x.id === 29);
    const tvear = teams.find(x => x.id === 30);

    const vearkstedOgGenbrug = teams.find(x => x.id === 24);
    const genbrug = teams.find(x => x.id === 31);
*/
    const unitBooking = units.find(x => x.id === model.unitId);


    const renderPersonChooser = (team) => {
        return(
            <div className='dialog-overlay' onClick={() => dispatch(setBookingField({ field: 'teamId', value: null }))}>
                <div className='dialog' onClick={(e) => e.stopPropagation()}>
                    <h1>Vælg en person</h1>
                    <div className='persons'>
                        <BookingPerson person={team.teamLeader} onClick={(pId) => dispatch(setBookingField({ field: 'personId', value: pId }))}/>
                        {team.members.map(x =>
                            <BookingPerson key={x.id} person={x} onClick={(pId) => dispatch(setBookingField({ field: 'personId', value: pId }))}  />
                        )}
                    </div>
                </div>
            </div>
        );
    };

    const renderTeam = (team) => {
        return(
            <div key={team.id} className={`team${model.teamId === team.id ? '' : ' active'}`} onClick={
                () => {
                    dispatch(setBookingField({ field: 'teamId', value: team.id }));
                    dispatch(setBookingField({ field: 'personId', value: null }));
                }}
            >
                <div className='text'>
                    <div>{team.name}</div>
                    <div className='text-muted text-sm'>{team.description}</div>
                </div>
            </div>
        )
    };

    const renderRow = (mainTeam, teams) => {
        if(mainTeam === null){
            return(
                <div className='team-row'>
                    {teams && teams.map(x => renderTeam(x))}
                </div>
            )
        }
        return(
            <div className='team-row'>
                <h2>{mainTeam.name}</h2>
                {renderTeam(mainTeam)}
                {teams && teams.map(x => renderTeam(x))}
            </div>
        )
    };

    if(model.teamId &&  !model.personId){
        return renderPersonChooser(teams.find(x => x.id === model.teamId));
    }

    return(
        <div className='dialog-overlay' onClick={() => dispatch(showTeamMenu(false))}>
            <div className='dialog teamchooser' onClick={(e) => e.stopPropagation()}>
                <div className='unit-container'>
                    <Unit unit={unitBooking} hideText noMenu hideName/>
                    <div className='clearfix'/>
                </div>
                <h1>{bookingPerson ? bookingPerson.name : 'Hvem'} reserverer "{unitBooking.name}"?</h1>
                {renderRow(null, teams)}
                {/*
                {renderRow(administration, [pladsen])}
                {renderRow(vejomraadet, [gronvej])}
                {renderRow(komunaleEjendome, [team2, team3, tvear])}
                {renderRow(vearkstedOgGenbrug, [genbrug])}
                */}
                <div className={`dialog-btn${model.teamId ? '' : ' disabled'}`} onClick={
                    () => {
                        dispatch(showTimeMenu(false));
                        dispatch(showTeamMenu(true));
                        dispatch(setTeamAndBook(model.teamId, model.personId));
                        const cb = { ...model, teamId: model.teamId, personId: model.personId };
                        dispatch(createBooking({
                            unitId: cb.unitId,
                            teamId: cb.teamId,
                            personId: cb.personId,
                            startTime: cb.startTime,
                            endTime: cb.endTime,
                        })); 
                    }}
                >Done</div>
            </div>
        </div>
    )
};

export default TeamChooser;